export const MIN_CARD_WIDTH = '60vw';
